const BASE_URL  = 'https://miagestion9008fapi.cloudc5.com';
const PROD_01   = 'https://miagestion9008fapi.cloudc5.com';
const PROD_02   = 'https://miagestion9008fapi.cloudc5.com';
const API_ASISTENCIA = {
  funciones: `${PROD_01}/api50h_param_read_funasis_get/`,
  tipoRegistros: `${PROD_01}/api50i_param_read_tipregasis_get/`,
  radios: `${PROD_01}/pi40frad_catrecur_listget/?skip=0&limit=1000`,
  camionetas: `${PROD_01}/pi40fcamio_catrecur_listget/?skip=0&limit=1000`,
  motos: `${PROD_01}/pi40fmotos_catrecur_listget/?skip=0&limit=1000`,
  puestosFijos: `${PROD_01}/pi40fpuestosfijos_catrecur_listget/?skip=0&limit=1000`,
  bicicletas: `${PROD_01}/pi40fbicicle_catrecur_listget/?skip=0&limit=1000`,
  usuarios: `${PROD_01}/pi120_M_MAES_SEREN_LIST/?skip=0&limit=1000`,
  serenosPorDNI: (documento) => `${PROD_01}/pi121_M_MAES_SEREN_DNIQR/${documento}/1/`,
  ConsultarRol: (documento) => `${PROD_01}/pi0401_RolAsig_listget/?VSERE_P_chDNI=${documento}&vcodopc_rol=ROL01`,
  ConsultaRolMes: (dnilogin) => `${PROD_01}/pi0401_RolAsig_listget/?VSERE_P_chDNI=${dnilogin}&vcodopc_rol=ROL02`,
  postasistencia: `${PROD_01}/pi011e_asis_sereno_entsal/?opc_fecha=fechoy`,
  mostrarfotodeusuario: (documento) => `${PROD_01}/pi20b100-download-archisql/${documento}/fotoperfil/1/`,
  enviarfotoevidencia: (documentousuario, documentoresponsable, latitud, longitud, valor) => 
    `${PROD_01}/pi11fil_upload_fil_asissql/?tipo_archivo=img&varchi_ch_codenlp=${documentousuario}&varchi_ch_codenls=${documentoresponsable}&varchi_ch_tiporeg=ASIS&varchifoto_in_act=1&vlat=${latitud}&vlon=${longitud}&vASIS_P_inID=${valor}`,
  autenticacion: (dni, clave) => `${PROD_01}/pi124_M_MAES_SEREN_LOGIN/${dni}/${clave}/`
};

export default API_ASISTENCIA;